// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* font Size */
.fs-67 {
  font-size: 67px;
}
.fs-53 {
  font-size: 53px;
}
.fs-50 {
  font-size: 50px;
}
.fs-49 {
  font-size: 49px;
}

.fs-45 {
  font-size: 45px;
}
.fs-41 {
  font-size: 41px;
}
.fs-40 {
  font-size: 40px;
}

.fs-35 {
  font-size: 35px;
}

.fs-32 {
  font-size: 32px;
}

.fs-32 {
  font-size: 32px;
}

.fs-30 {
  font-size: 30px;
}

.fs-29 {
  font-size: 29px;
}

.fs-28 {
  font-size: 28px;
}

.fs-27 {
  font-size: 27px;
}

.fs-25 {
  font-size: 25px;
}

.fs-23 {
  font-size: 23px;
}
.fs-22 {
  font-size: 22px;
}

.fs-21 {
  font-size: 21px;
}

.fs-20 {
  font-size: 20px;
}
.fs-19 {
  font-size: 19px;
}
.fs-18 {
  font-size: 18px;
}

.fs-16 {
  font-size: 16px;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-13 {
  font-size: 13px;
}

.fs-12 {
  font-size: 12px;
}

.fs-10 {
  font-size: 10px;
}

/* font weight */

.fw-300 {
  font-weight: 300;
}
.fw-400 {
  font-weight: 400;
}
.fw-500 {
  font-weight: 500;
}
.fw-600 {
  font-weight: 600;
}
.fw-700 {
  font-weight: 700;
}

@media (max-width: 992px) {
  .fs-40,
  .fs-50 {
    font-size: 35px;
  }
  .fs-32 {
    font-size: 25px;
  }
}

@media (max-width: 576px) {
  .fs-24 {
    font-size: 20px;
  }
  .fs-18 {
    font-size: 15px;
  }
  .fs-16 {
    font-size: 14px;
  }
  .fs-20 {
    font-size: 16px;
  }
  .fs-32 {
    font-size: 20px;
  }
  .fs-30 {
    font-size: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/typography.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* font Size */\n.fs-67 {\n  font-size: 67px;\n}\n.fs-53 {\n  font-size: 53px;\n}\n.fs-50 {\n  font-size: 50px;\n}\n.fs-49 {\n  font-size: 49px;\n}\n\n.fs-45 {\n  font-size: 45px;\n}\n.fs-41 {\n  font-size: 41px;\n}\n.fs-40 {\n  font-size: 40px;\n}\n\n.fs-35 {\n  font-size: 35px;\n}\n\n.fs-32 {\n  font-size: 32px;\n}\n\n.fs-32 {\n  font-size: 32px;\n}\n\n.fs-30 {\n  font-size: 30px;\n}\n\n.fs-29 {\n  font-size: 29px;\n}\n\n.fs-28 {\n  font-size: 28px;\n}\n\n.fs-27 {\n  font-size: 27px;\n}\n\n.fs-25 {\n  font-size: 25px;\n}\n\n.fs-23 {\n  font-size: 23px;\n}\n.fs-22 {\n  font-size: 22px;\n}\n\n.fs-21 {\n  font-size: 21px;\n}\n\n.fs-20 {\n  font-size: 20px;\n}\n.fs-19 {\n  font-size: 19px;\n}\n.fs-18 {\n  font-size: 18px;\n}\n\n.fs-16 {\n  font-size: 16px;\n}\n\n.fs-15 {\n  font-size: 15px;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.fs-13 {\n  font-size: 13px;\n}\n\n.fs-12 {\n  font-size: 12px;\n}\n\n.fs-10 {\n  font-size: 10px;\n}\n\n/* font weight */\n\n.fw-300 {\n  font-weight: 300;\n}\n.fw-400 {\n  font-weight: 400;\n}\n.fw-500 {\n  font-weight: 500;\n}\n.fw-600 {\n  font-weight: 600;\n}\n.fw-700 {\n  font-weight: 700;\n}\n\n@media (max-width: 992px) {\n  .fs-40,\n  .fs-50 {\n    font-size: 35px;\n  }\n  .fs-32 {\n    font-size: 25px;\n  }\n}\n\n@media (max-width: 576px) {\n  .fs-24 {\n    font-size: 20px;\n  }\n  .fs-18 {\n    font-size: 15px;\n  }\n  .fs-16 {\n    font-size: 14px;\n  }\n  .fs-20 {\n    font-size: 16px;\n  }\n  .fs-32 {\n    font-size: 20px;\n  }\n  .fs-30 {\n    font-size: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
